"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDown = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const ChevronDown = ({ colour = "#E6E6E6", size = 16, title = "Expand section", ...rest }) => (react_1.default.createElement(Base_1.Base, { size: size, fill: colour, smooth: true, ...rest },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M8,9l3-4l2,0l-5,7l-5,-7l2,0z" })));
exports.ChevronDown = ChevronDown;
//# sourceMappingURL=ChevronDown.js.map